import BaseStore from '@store/table'
import Api from '@api/xi_feng/case'

class Store extends BaseStore {
  id

  $listApi = Api.getSelectImg

  $getParams = () => {
    return {
      sample_id: this.id,
      ...this.$params
    }
  }
}

export default new Store()
